export default "__VITE_ASSET__CJCHhX10__"